import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
function UseQuery() {
  const { search } = useLocation();

  const querySearch = React.useMemo(() => new URLSearchParams(search), [search]);

  const query = Object.fromEntries(querySearch.entries());
  const getQuery = useCallback(() => {
    return Object.fromEntries(querySearch.entries());
  }, [querySearch]);

  return {
    query: query,
    getQuery
  };
}

export default UseQuery;
